import type {
  GenericCharge,
  IOfferSmiles,
  ICharge,
} from '@smiles/core-traveler-universe/dist/Types/Hotels/Details.types';

const Types = {
  SET_PAYMENT: 'checkout/SET_PAYMENT',
};

export type PaymentValue = IOfferSmiles | { normal: number; club: number } | number;

export type MilesPayment = {
  type: 'SMILES';
  value: { normal: number; club: number };
};

export type MoneyPayment = {
  type: 'MONEY';
  value: number;
};

export type SmilesAndMoneyPayment = {
  type: 'SMILES_AND_MONEY';
  value: IOfferSmiles;
};
export interface ICheckoutReduxState {
  payment: GenericCharge<ICharge> | null;
}

const initialState: ICheckoutReduxState = {
  payment: null,
};

export default function reducer(state = initialState, action: any = {}): ICheckoutReduxState {
  if (action.type === Types.SET_PAYMENT) {
    return { ...state, payment: action.payload };
  }

  return state;
}

const setPayment = (payment: ICharge) => ({
  type: Types.SET_PAYMENT,
  payload: payment,
});

export const checkoutActions = { setPayment };
